import * as React from 'react';
import { HiddenA11yText, StyledExternalLink, ExternalText, StyledExternalIcon } from './ExternalLink.styles';

const ExternalIcon = ({ children }) => (
    <>
        <StyledExternalIcon aria-hidden="true" />
        {children}
        <HiddenA11yText>, öppnar annan webbplats</HiddenA11yText>
    </>
);

type Props = {
    href: string;
    children: React.ReactNode;
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
};

const ExternalLink = ({ children, href, className, onClick }: Props) => (
    <StyledExternalLink href={href} className={className} onClick={onClick}>
        <ExternalIcon>
            <ExternalText>{children}</ExternalText>
        </ExternalIcon>
    </StyledExternalLink>
);

export default ExternalLink;
